import {getLocalData} from "./StorageServices";

const _store = {
    state: getLocalData('app', {})
};

export const getAppVersion = () => {
    const app = _store.state;

    return app ? app.version : '1.0.0';
};


// WEBPACK FOOTER //
// ./src/services/AppServices.js